import { theme } from "antd";

export const designTokens = {
  // Content
  colorContentBase: "var(--color-content-base)",
  colorContentSecondary: "var(--color-content-secondary)",
  colorContentTertiary: "var(--color-content-tertiary)",
  colorContentDisabled: "var(--color-content-disabled)",
  colorContentInverse: "var(--color-content-inverse)",
  colorContentDarkbluePrimary: "var(--color-content-darkblue-primary)",

  // Warm
  colorDark: "var(--color-dark)",
  colorPrimary: "var(--color-primary)",
  colorSecondary: "var(--color-secondary)",
  colorDisabled: "var(--color-disabled)",
  colorSurface: "var(--color-surface)",

  // Cool
  colorCoolDark: "var(--color-cool-dark)",
  colorCoolPrimary: "var(--color-cool-primary)",
  colorCoolSecondary: "var(--color-cool-secondary)",
  colorCoolDisabled: "var(--color-cool-disabled)",
  colorCoolSurface: "var(--color-cool-surface)",

  // Scrollbar
  colorScrollbarThumb: "var(--color-scrollbar-thumb)",
  colorScrollbarThumbHover: "var(--color-scrollbar-thumb-hover)",

  // Background
  colorBgPrimary: "var(--color-bg-primary)",
  colorBgCanvas: "var(--color-bg-canvas)",
  colorBgSecondarySoft: "var(--color-bg-secondary-soft)",
  colorBgSecondary: "var(--color-bg-secondary)",
  colorBgTertiary: "var(--color-bg-tertiary)",
  colorBgDisabled: "var(--color-bg-disabled)",

  // Border
  colorBorderPrimary: "var(--color-border-primary)",
  colorBorderSecondary: "var(--color-border-secondary)",
  colorBorderTertiary: "var(--color-border-tertiary)",
  colorBorderDisabled: "var(--color-border-disabled)",
  colorBorderFocus: "var(--color-border-focus)",
  colorInputBorder: "var(--color-input-border)",
  colorInputBorderFocus: "var(--color-input-border-focus)",
  colorInputBorderError: "var(--color-input-border-error)",

  // Accent
  colorContentPositive: "var(--color-content-positive)",
  colorContentWarning: "var(--color-content-warning)",
  colorContentWarningText: "var(--color-content-warning-text)",
  colorContentNegative: "var(--color-content-negative)",
  colorContentPositiveBg: "var(--color-content-positive-bg)",
  colorContentWarningBg: "var(--color-content-warning-bg)",
  colorContentNegativeBg: "var(--color-content-negative-bg)",

  // Analytics
  colorAnalyticsPurple: "var(--color-analytics-purple)",
  colorAnalyticsBlue: "var(--color-analytics-blue)",
  colorAnalyticsRust: "var(--color-analytics-rust)",
  colorAnalyticsTealGreen: "var(--color-analytics-teal-green)",
  colorAnalyticsPink: "var(--color-analytics-pink)",
  colorAnalyticsSage: "var(--color-analytics-sage)",

  colorAnalyticsPurpleBg: "var(--color-analytics-purple-bg)",
  colorAnalyticsBlueBg: "var(--color-analytics-blue-bg)",
  colorAnalyticsRustBg: "var(--color-analytics-rust-bg)",
  colorAnalyticsTealBg: "var(--color-analytics-teal-bg)",
  colorAnalyticsPinkBg: "var(--color-analytics-pink-bg)",
  colorAnalyticsSageBg: "var(--color-analytics-sage-bg)",
  colorAnalyticsPill1Bg: "var(--color-analytics-pill1-bg)",

  // Usage progress
  colorUsageProgressTrack: "var(--color-usage-progress-track)",
  colorUsageProgressStripe: "var(--color-usage-progress-stripe)",

  colorUsageHealthyProgress: "var(--color-usage-healthy-progress)",
  colorUsageHealthyText: "var(--color-usage-healthy-text)",
  colorUsageHealthyBg: "var(--color-usage-healthy-bg)",

  colorUsageWarningProgress: "var(--color-usage-warning-progress)",
  colorUsageWarningText: "var(--color-usage-warning-text)",
  colorUsageWarningBg: "var(--color-usage-warning-bg)",

  colorUsageCriticalProgress: "var(--color-usage-critical-progress)",
  colorUsageCriticalText: "var(--color-usage-critical-text)",
  colorUsageCriticalBg: "var(--color-usage-critical-bg)",

  colorUsageCategoryMicrobiology: "var(--color-usage-category-microbiology)",
  colorUsageCategoryChemistry: "var(--color-usage-category-chemistry)",
  colorUsageCategoryEnvironment: "var(--color-usage-category-environment)",

  // Loading / skeleton shimmer
  colorSkeletonGradientFrom: "var(--color-skeleton-gradient-from)",
  colorSkeletonGradientTo: "var(--color-skeleton-gradient-to)",

  // Radius
  radiusNone: "var(--radius-none)",
  radiusXSm: "var(--radius-x-sm)",
  radiusSm: "var(--radius-sm)",
  radiusMd: "var(--radius-md)",
  radiusLg: "var(--radius-lg)",
  radiusXLg: "var(--radius-x-lg)",
  radiusXxLg: "var(--radius-xx-lg)",
  radiusFull: "var(--radius-full)",

  // Shadow
  shadowXxSm: "var(--shadow-xx-sm)",
  shadowXSm: "var(--shadow-x-sm)",
  shadowSm: "var(--shadow-sm)",
  shadowMd: "var(--shadow-md)",
  shadowLg: "var(--shadow-lg)",
  shadowIconXSm: "var(--shadow-icon-x-sm)",

  // Spacing
  spacingXxxSm: "var(--spacing-xxx-sm)",
  spacingXxSm: "var(--spacing-xx-sm)",
  spacingXSm: "var(--spacing-x-sm)",
  spacingSm: "var(--spacing-sm)",
  spacingMd: "var(--spacing-md)",
  spacingBig: "var(--spacing-big)",
  spacingXBig: "var(--spacing-x-big)",
  spacingXxBig: "var(--spacing-xx-big)",
  spacingXxxBig: "var(--spacing-xxx-big)",
  spacingLg: "var(--spacing-lg)",
  spacingXLg: "var(--spacing-x-lg)",
  spacingXxLg: "var(--spacing-xx-lg)",
  spacingXxxLg: "var(--spacing-xxx-lg)",
  spacingHuge: "var(--spacing-huge)",
  spacingXHuge: "var(--spacing-x-huge)",
  spacingXxHuge: "var(--spacing-xx-huge)",
  spacingXxxHuge: "var(--spacing-xxx-huge)",

  // Typography — Label/label-lg
  fontLabelLgFamily: "var(--font-label-lg-family)",
  fontLabelLgWeight: "var(--font-label-lg-weight)",
  fontLabelLgSize: "var(--font-label-lg-size)",
  fontLabelLgLineHeight: "var(--font-label-lg-line-height)",
  fontLabelLgLetterSpacing: "var(--font-label-lg-letter-spacing)",
};

export const AnalyticsColors = [
  {
    color: designTokens.colorAnalyticsPurple,
    backgroundColor: designTokens.colorAnalyticsPurpleBg,
  },
  {
    color: designTokens.colorAnalyticsBlue,
    backgroundColor: designTokens.colorAnalyticsBlueBg,
  },
  {
    color: designTokens.colorAnalyticsRust,
    backgroundColor: designTokens.colorAnalyticsRustBg,
  },
  {
    color: designTokens.colorAnalyticsTealGreen,
    backgroundColor: designTokens.colorAnalyticsTealBg,
  },
  {
    color: designTokens.colorAnalyticsPink,
    backgroundColor: designTokens.colorAnalyticsPinkBg,
  },
  {
    color: designTokens.colorAnalyticsSage,
    backgroundColor: designTokens.colorAnalyticsSageBg,
  },
];

export function getAntdTheme(isDark) {
  return {
    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,

    token: {
      // Brand
      colorPrimary: designTokens.colorPrimary,
      colorInfo: designTokens.colorPrimary,
      colorPrimaryHover: designTokens.colorDark,
      colorPrimaryActive: designTokens.colorDark,

      // State
      colorSuccess: designTokens.colorContentPositive,
      colorError: designTokens.colorContentNegative,
      colorWarning: designTokens.colorContentWarning,

      // Text
      colorText: designTokens.colorContentBase,
      colorTextSecondary: designTokens.colorContentSecondary,
      colorTextTertiary: designTokens.colorContentSecondary,
      colorTextQuaternary: designTokens.colorContentSecondary,
      colorTextHeading: designTokens.colorContentBase,
      colorTextDescription: designTokens.colorContentSecondary,
      colorTextPlaceholder: designTokens.colorContentTertiary,
      colorTextDisabled: designTokens.colorContentDisabled,
      colorTextLightSolid: designTokens.colorContentInverse,

      // Borders & surfaces
      colorBorder: designTokens.colorBorderSecondary,
      colorBorderSecondary: designTokens.colorBorderSecondary,
      colorBgContainer: designTokens.colorBgPrimary,
      colorBgElevated: designTokens.colorBgPrimary,
      colorBgLayout: designTokens.colorBgPrimary,
      colorBgSpotlight: designTokens.colorSurface,

      // Fills
      colorFillAlter: designTokens.colorSurface,
      colorFillSecondary: designTokens.colorDisabled,
      // colorFillTertiary: designTokens.colorSurface,
      colorFillQuaternary: designTokens.colorSurface,

      // Links
      colorLink: designTokens.colorPrimary,
      colorLinkHover: designTokens.colorDark,
      colorLinkActive: designTokens.colorDark,

      // State backgrounds
      colorSuccessBg: designTokens.colorSurface,
      colorErrorBg: designTokens.colorSurface,
      colorWarningBg: designTokens.colorSurface,

      // Outlines
      colorErrorOutline: designTokens.colorContentNegative,
      colorWarningOutline: designTokens.colorContentWarning,
    },

    components: {
      Button: {
        colorPrimary: designTokens.colorPrimary,

        primaryShadow: "none",
        defaultShadow: "none",

        defaultBg: designTokens.colorBgPrimary,
        defaultHoverBg: designTokens.colorBgSecondary,
        defaultActiveBg: designTokens.colorBgSecondary,

        defaultColor: designTokens.colorContentBase,
        defaultHoverColor: designTokens.colorContentBase,
        defaultActiveColor: designTokens.colorContentBase,

        defaultBorderColor: designTokens.colorBorderPrimary,
        defaultHoverBorderColor: designTokens.colorBorderSecondary,
        defaultActiveBorderColor: designTokens.colorBorderSecondary,

        colorTextDisabled: designTokens.colorContentDisabled,
        colorBgContainerDisabled: designTokens.colorBgDisabled,
        borderColorDisabled: designTokens.colorBorderDisabled,

        // Text button (type="text") — Label/label-lg + Content++ Primary
        textTextColor: designTokens.colorPrimary,
        textTextHoverColor: designTokens.colorDark,
        textTextActiveColor: designTokens.colorDark,
        textHoverBg: "transparent",
        linkHoverBg: "transparent",
        iconGap: 8,
      },

      Input: {
        colorBgContainer: designTokens.colorBgPrimary,
        colorBorder: designTokens.colorInputBorder,
        hoverBg: designTokens.colorBgPrimary,
        activeBorderColor: designTokens.colorInputBorderFocus,
        hoverBorderColor: designTokens.colorInputBorderFocus,

        colorText: designTokens.colorContentBase,
        colorTextPlaceholder: designTokens.colorContentTertiary,
        colorTextDisabled: designTokens.colorContentDisabled,
        colorBgContainerDisabled: designTokens.colorBgDisabled,

        activeShadow: "none",
        errorActiveShadow: "none",
        colorError: designTokens.colorInputBorderError,
      },

      InputNumber: {
        colorBgContainer: designTokens.colorBgPrimary,
        colorBorder: designTokens.colorInputBorder,
        hoverBg: designTokens.colorBgPrimary,
        hoverBorderColor: designTokens.colorInputBorderFocus,
        activeBorderColor: designTokens.colorInputBorderFocus,
        activeShadow: "none",
        colorText: designTokens.colorContentBase,
        colorTextPlaceholder: designTokens.colorContentTertiary,
        colorTextDisabled: designTokens.colorContentDisabled,
        colorError: designTokens.colorInputBorderError,
      },

      Select: {
        colorBgContainer: designTokens.colorBgPrimary,
        colorBorder: designTokens.colorInputBorder,
        hoverBorderColor: designTokens.colorInputBorderFocus,
        activeBorderColor: designTokens.colorInputBorderFocus,
        activeShadow: "none",
        colorText: designTokens.colorContentBase,
        colorTextPlaceholder: designTokens.colorContentTertiary,
        optionActiveBg: designTokens.colorBgSecondary, // hover #F7F9F8
        optionSelectedBg: designTokens.colorCoolSurface, // selected #ECF3F2
        optionSelectedColor: designTokens.colorCoolPrimary, // selected text #0F4A43
        optionSelectedFontWeight: 400, // Body regular — not medium/bold
        multipleItemBg: designTokens.colorCoolSurface,
        multipleItemBorderColor: designTokens.colorCoolSecondary,
        colorError: designTokens.colorInputBorderError,
      },

      Checkbox: {
        colorBorder: designTokens.colorSecondary,
        colorPrimary: designTokens.colorPrimary,
        colorPrimaryHover: designTokens.colorDark,
      },

      Radio: {
        colorPrimary: designTokens.colorPrimary,
        colorPrimaryHover: designTokens.colorPrimary,
        colorText: designTokens.colorContentTertiary,
        colorTextDisabled: designTokens.colorContentDisabled,
        colorBorder: designTokens.colorContentTertiary,
        buttonColor: designTokens.colorSecondary,
        buttonSolidCheckedBg: designTokens.colorPrimary,
        buttonSolidCheckedHoverBg: designTokens.colorDark,
        buttonSolidCheckedColor: designTokens.colorContentInverse,
        buttonCheckedBg: designTokens.colorPrimary,
        radioSize: 16,
        dotSize: 8,
      },

      Tooltip: {
        colorBgSpotlight: designTokens.colorContentBase,
        colorTextLightSolid: designTokens.colorContentInverse,
      },

      Switch: {
        colorPrimary: designTokens.colorPrimary,
        colorPrimaryHover: designTokens.colorDark,
      },

      Skeleton: {
        gradientFromColor: designTokens.colorSkeletonGradientFrom,
        gradientToColor: designTokens.colorSkeletonGradientTo,
      },
    },
  };
}

export const antdAppTheme = getAntdTheme(false);
